module.exports = __webpack_public_path__ + "static/CGC-c90c01097fc76da5f405be66f93965d1.png";